export default __webpack_public_path__ + "static/media/orderSong.369d7fb3.mp3";